<script setup>
const props = defineProps({
  isClose: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: "default" // default, red, yellow, green, blue
  }
});

const emit = defineEmits(["close"]);

function onClose(e) {
  e.stopPropagation(); // Prevents the event from bubbling up
  emit("close");
}

function onClick(e) {
  e.stopPropagation(); // Prevents the event from bubbling up
}

</script>

<template>
  <div class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset " :class="{
    'tag-default': props.color === 'default',
    'tag-red': props.color === 'red',
    'tag-yellow': props.color === 'yellow',
    'tag-green': props.color === 'green',
    'tag-blue': props.color === 'blue',
    'tag-purple': props.color === 'purple',
  }" @click.prevent="onClick">
    <div class="select-none text-xs pointer-events-none line-clamp-1 break-all" @click.prevent="onClick">
      <slot></slot>
    </div>
    <div v-if="isClose" class="text-sm flex items-center text-gray-500 dark:text-gray-400 cursor-pointer hover:text-black hover:dark:text-gray-100 p-1"
      @click.prevent="onClose">
      <span class="fa fa-close"></span>
    </div>
  </div>
</template>


<style scoped>
.tag-default {
  @apply text-gray-900 dark:bg-gray-900 dark:text-gray-100 ring-gray-400 dark:ring-gray-600;
}

.tag-red {
  @apply bg-red-50 text-red-700 ring-red-600/10
    dark:bg-red-600 dark:text-red-200 dark:ring-red-800;
}

.tag-yellow {
  @apply bg-yellow-50 text-yellow-800 ring-yellow-600/20
    dark:bg-yellow-300 dark:text-yellow-900 dark:ring-yellow-400;
}

.tag-green {
  @apply bg-green-50 text-green-700 ring-green-600/20
    dark:bg-emerald-600 dark:text-green-100;
}

.tag-blue {
  @apply bg-blue-50/60 dark:bg-blue-900 text-blue-800 dark:text-blue-200 ring-blue-400/20;
}

.tag-purple {
  @apply bg-purple-50/60 dark:bg-purple-900 text-purple-800 dark:text-purple-200 ring-purple-400/20;
}
</style>